<template>
  <page-section :title="$t('ProfileVoucherCodes_Title')">
    <rest-list :payload="fetchEndpoint">
      <rest-list-column-date
        prop="time"
        :title="$t('ProfileVoucherCodes_Field_Date')"
        :width="200"
      />

      <rest-list-column
        prop="campaign_title"
        :min-width="150"
        :title="$t('ProfileVoucherCodes_Field_CampaignTitle')"
        :sortable="false"
      >
        <template slot-scope="scope">
          <router-link :to="campaignRoute(scope.row)">
            {{ scope.row.campaign_title }}
          </router-link>
        </template>
      </rest-list-column>

      <rest-list-column
        prop="code"
        :title="$t('ProfileVoucherCodes_Field_VoucherCode')"
        :sortable="false"
      />
    </rest-list>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
export default {
  name: 'ProfileAuditLog',

  components: {
    RestListColumnDate,
    RestListColumn,
    RestList,
    PageSection
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.$route.query.profile_id}/voucher-codes`,
        params: {
          expand: 'campaign_title',
          sort: '-time'
        }
      })
    }
  },

  methods: {
    campaignRoute(row) {
      return projectRoute({
        path: `/push/campaign/${this.readonly ? 'view' : 'update'}`,
        query: { id: row.campaign_id }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileVoucherCodes.vue